import {getLanguageList, getTourLanguageList, newLanguage, newTourLanguage, removeTourLanguage, removeTourLanguages, updateTourLanguages} from '../../services/LanguageService';

export default {
  namespaced: true,
  state: {
    initialLanguages: [],
    languageList: [],
    tourLanguageList: [],
    checkRouteIsMappingTable: false
  },
  getters: {
    getLanguageList: (state) => {
      return state.languageList;
    },
    getTourLanguageList: (state) => {
      return state.tourLanguageList;
    },
    checkRouteIsMappingTable: (state) => {
      return state.checkRouteIsMappingTable;
    },
    tourLanguagesReordered: (state) => {
      let reordered = false;
      for (let [index, lang] of state.tourLanguageList.entries()) {
        if (!state.initialLanguages[index] || lang.order !== state.initialLanguages[index].order) {
          reordered = true;
          break;
        }
      }

      return reordered;
    }
  },
  mutations: {
    setLanguageList (state, languages) {
      state.languageList = languages;
    },
    setTourLanguageList (state, tourLanguages) {
      state.initialLanguages = tourLanguages;
      state.tourLanguageList = tourLanguages;
    },
    checkRouteIsMappingTable (state, data) {
      state.checkRouteIsMappingTable = data;
    },
    updateLanguageOrderForTour (state, data) {
      state.tourLanguageList = data.languages;
      for (var [index, language] of state.tourLanguageList.entries()) {
        language.order = index;
      }
    },
    updateInitialLanguages (state, languages) {
      state.initialLanguages = languages;
    }

  },
  actions: {
    async loadLanguageList ({commit}) {
      const languages = await getLanguageList();
      commit('setLanguageList', languages.data);
    },
    async changeStateRouteIsMappingTable ({commit}, data) {
      commit('checkRouteIsMappingTable', data);
    },
    async loadTourLanguageList ({commit}, tourId) {
      const tourLanguages = await getTourLanguageList(tourId);
      commit('setTourLanguageList', tourLanguages.data);
      commit('updateInitialLanguages', tourLanguages.data);
    },
    async createLanguage ({commit}, data) {
      try {
        await newLanguage(data);
      } catch (error) {
        console.log(error);
      }
    },
    async addTourLanguage ({commit}, data) {
      try {
        let result = await newTourLanguage(data);
        if (result.data === 'success') {
          const tourLanguages = await getTourLanguageList(data.tourId);
          commit('setTourLanguageList', tourLanguages.data);
          commit('updateInitialLanguages', tourLanguages.data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async removeTourLanguage ({commit}, data) {
      try {
        let result = await removeTourLanguage(data);
        if (result.data === 0) {
          commit('checkRouteIsMappingTable', true);
        }
        if (result.data === 'success') {
          const tourLanguages = await getTourLanguageList(data.tourId);
          commit('setTourLanguageList', tourLanguages.data);
          commit('updateInitialLanguages', tourLanguages.data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async removeTourLanguages ({commit}, data) {
      try {
        let result = await removeTourLanguages(data);
        if (result.data === 'success') {
          commit('checkRouteIsMappingTable', false);
          const tourLanguages = await getTourLanguageList(data.tourId);
          commit('setTourLanguageList', tourLanguages.data);
          commit('updateInitialLanguages', tourLanguages.data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    updateLanguageOrder ({commit}, data) {
      commit('updateLanguageOrderForTour', data);
    },
    async updateTourLanguages ({commit}, data) {
      try {
        await updateTourLanguages(data);
      } catch (error) {
        console.log(error);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/languageModule.js